import * as React from 'react'
import { ReactNode } from 'react'
import Typography from '@mui/material/Typography'

type Props = {
  children: ReactNode
  mt?: number
  mb?: number
}

export function TitleSection(props: Props) {
  const { children } = props
  return (
    <Typography variant="h5" noWrap {...props}>
      {children}
    </Typography>
  )
}
